import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import {
  ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS,
  REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS,
} from 'redux/modules/referralSources';

// Actions
export const FETCH_SALES_REPRESENTATIVES = 'FETCH_SALES_REPRESENTATIVES';
export const FETCH_SALES_REPRESENTATIVES_SUCCESS = 'FETCH_SALES_REPRESENTATIVES_SUCCESS';
export const FETCH_SALES_REPRESENTATIVES_FAIL = 'FETCH_SALES_REPRESENTATIVES_FAIL';
export const CLEAR_SALES_REPRESENTATIVES = 'CLEAR_SALES_REPRESENTATIVES';
export const CREATE_SALES_REPRESENTATIVE = 'CREATE_SALES_REPRESENTATIVE';
export const CREATE_SALES_REPRESENTATIVE_SUCCESS = 'CREATE_SALES_REPRESENTATIVE_SUCCESS';
export const CREATE_SALES_REPRESENTATIVE_FAIL = 'CREATE_SALES_REPRESENTATIVE_FAIL';
export const UPDATE_SALES_REPRESENTATIVE = 'UPDATE_SALES_REPRESENTATIVE';
export const UPDATE_SALES_REPRESENTATIVE_SUCCESS = 'UPDATE_SALES_REPRESENTATIVE_SUCCESS';
export const UPDATE_SALES_REPRESENTATIVE_FAIL = 'UPDATE_SALES_REPRESENTATIVE_FAIL';
export const DELETE_SALES_REPRESENTATIVE = 'DELETE_SALES_REPRESENTATIVE';
export const DELETE_SALES_REPRESENTATIVE_SUCCESS = 'DELETE_SALES_REPRESENTATIVE_SUCCESS';
export const DELETE_SALES_REPRESENTATIVE_FAIL = 'DELETE_SALES_REPRESENTATIVE_FAIL';

// Reducer
export default function salesRepresentativesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_SALES_REPRESENTATIVES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_SALES_REPRESENTATIVES_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_SALES_REPRESENTATIVES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_SALES_REPRESENTATIVES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case CREATE_SALES_REPRESENTATIVE_SUCCESS: {
      const newData = [
        ...state.data.slice(0, state.data.length),
        payload,
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
      };
    }
    case UPDATE_SALES_REPRESENTATIVE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_SALES_REPRESENTATIVE_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS: {
      const newData = state.data.map((item) => {
        if (payload['Sales Representative'].filter(salesItem => salesItem.ID === item.ID).length > 0
          && item['Referral Source'].findIndex(referralSourceItem => referralSourceItem.ID === payload.ID) === -1) {
          return {
            ...item,
            'Referral Source': [
              ...item['Referral Source'],
              payload,
            ],
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        data: newData,
      };
    }
    case REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS: {
      const newData = state.data.map((item) => {
        const removedReferralSourceIndex = item['Referral Source'].findIndex(referralSourceItem =>
          referralSourceItem.ID === payload.ID && payload['Sales Representative'].filter(salesItem => salesItem.ID === item.ID).length === 0);
        if (removedReferralSourceIndex === -1) {
          return item;
        } else {
          return {
            ...item,
            'Referral Source': [
              ...item['Referral Source'].slice(0, removedReferralSourceIndex),
              ...item['Referral Source'].slice(removedReferralSourceIndex + 1),
            ],
          };
        }
      });
      return {
        ...state,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchSalesRepresentatives(payload) {
  return { type: FETCH_SALES_REPRESENTATIVES, payload };
}

export function fetchSalesRepresentativesSuccess(payload) {
  return { type: FETCH_SALES_REPRESENTATIVES_SUCCESS, payload };
}

export function fetchSalesRepresentativesFail(payload) {
  return { type: FETCH_SALES_REPRESENTATIVES_FAIL, payload };
}

export function clearSalesRepresentatives(payload) {
  return { type: CLEAR_SALES_REPRESENTATIVES, payload };
}

export function createSalesRepresentative(payload) {
  return { type: CREATE_SALES_REPRESENTATIVE, payload };
}

export function createSalesRepresentativeSuccess(payload) {
  return { type: CREATE_SALES_REPRESENTATIVE_SUCCESS, payload };
}

export function createSalesRepresentativeFail(payload) {
  return { type: CREATE_SALES_REPRESENTATIVE_FAIL, payload };
}

export function updateSalesRepresentative(payload) {
  return { type: UPDATE_SALES_REPRESENTATIVE, payload };
}

export function updateSalesRepresentativeSuccess(payload) {
  return { type: UPDATE_SALES_REPRESENTATIVE_SUCCESS, payload };
}

export function updateSalesRepresentativeFail(payload) {
  return { type: UPDATE_SALES_REPRESENTATIVE_FAIL, payload };
}

export function deleteSalesRepresentative(payload) {
  return { type: DELETE_SALES_REPRESENTATIVE, payload };
}

export function deleteSalesRepresentativeSuccess(payload) {
  return { type: DELETE_SALES_REPRESENTATIVE_SUCCESS, payload };
}

export function deleteSalesRepresentativeFail(payload) {
  return { type: DELETE_SALES_REPRESENTATIVE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchSalesRepresentatives({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi(`resource/sales_representative/?limit=${limit}&offset=${offset}`);
  abort = request.abort;
  return request.res;
}

export function requestSearchSalesRepresentatives({ limit, offset, filters }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('resource/sales_representative/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'First Name',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestCreateSalesRepresentative(payload) {
  return callApi('resource/sales_representative/', 'POST', payload);
}

export function requestUpdateSalesRepresentative(payload) {
  return callApi('resource/sales_representative/', 'PATCH', payload);
}

export function requestDeleteSalesRepresentative(payload) {
  return callApi(`resource/sales_representative/?id=${payload}`, 'DELETE');
}

// Sagas
function* fetchSalesRepresentativesSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = filters
      ? yield call(requestSearchSalesRepresentatives, action.payload)
      : yield call(requestFetchSalesRepresentatives, action.payload);
    yield put(fetchSalesRepresentativesSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchSalesRepresentativesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createSalesRepresentativeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateSalesRepresentative, values);
    yield put(createSalesRepresentativeSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New sales representative successfully added',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createSalesRepresentativeFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateSalesRepresentativeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateSalesRepresentative, values);
    yield put(updateSalesRepresentativeSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Sales representative successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateSalesRepresentativeFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteSalesRepresentativeSaga(action) {
  const { ID } = action.payload;
  try {
    const res = yield call(requestDeleteSalesRepresentative, ID);
    yield put(deleteSalesRepresentativeSuccess({ ID }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Sales representative successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deleteSalesRepresentativeFail(err.data));
    yield put(addNotification({
      message: 'Failed to delete sales representative',
      variant: 'warning',
    }));
  }
}

export function* salesRepresentativesSaga() {
  yield takeLatest(FETCH_SALES_REPRESENTATIVES, fetchSalesRepresentativesSaga);
  yield takeEvery(CREATE_SALES_REPRESENTATIVE, createSalesRepresentativeSaga);
  yield takeEvery(UPDATE_SALES_REPRESENTATIVE, updateSalesRepresentativeSaga);
  yield takeEvery(DELETE_SALES_REPRESENTATIVE, deleteSalesRepresentativeSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/salesRepresentatives.js